import { SeoHead } from "@/ui/SeoHead";
import getPaths from "@sourceflow-uk/functions/getPaths";
import { ContentBlocks } from "src/ui/ContentBlocks";

import useSector from "@/hooks/useSector";

export default function BlogPostPage({ prefix, title, canonical, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const { id, name, image, description, skills } = useSector(url_slug);

  return {
    props: {
      prefix: `sector_${url_slug}`,
      title: name,
      canonical: `/expertise/${url_slug}/`,
      url_slug,
      data: [
        { component: "Hero", props: { title: name, image } },
        {
          component: "Content",
          props: {
            className: "",
            tagline: "Overview",
            title: `We’re Sector Experts In ${name}`,
            description,
          },
        },
        // {
        //   component: "ContentSubMenu",
        //   props: {
        //     className: "py-4 py-md-5",
        //     title: "Title of Sub-sector",
        //     description: `<p>Roles of ${name}</p>`,
        //     items: [
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //       "Sub-sector",
        //     ],
        //   },
        // },
        {
          component: "JobsCarousel",
          props: {
            className: "py-5 py-md-6 text-center overflow-hidden",
            title: `Latest Jobs in ${name}`,
            description: "<p>Your next opportunity is just a click away!</p>",
            __sector: id,
          },
        },
        {
          component: "SectorSkillsMobile",
          props: {
            className: "py-4 py-md-5",
            title: `Sector and Field Skills`,
            description: `<p>Roles of ${name}</p>`,
            Sector_id: `${id}`,
            Sector_skills: `${skills}`,
          },
        },
        {
          component: "SectorSkills",
          props: {
            className: "py-4 py-md-5",
            title: `Sector and Field Skills`,
            description: `<p>Roles of ${name}</p>`,
            Sector_id: `${id}`,
            Sector_skills: `${skills}`,
          },
        },
        {
          component: "SectorRoles",
          props: {
            className: "py-4 py-md-5",
            title: "Title of Sub-sector",
            // description: `<p>Roles of ${name}</p>`,
            Sector_id: `${id}`,
          },
        },
        {
          component: "SectorTeam",
          props: {
            className: "py-5 py-md-6",
            title: `Meet our ${name} Team`,
            description: `<p>Get to know the specialists you'll be working with in ${name}.</p>`,
            __sector: id,
          },
        },
        {
          component: "ReviewsCarousels",
          props: {
            className: "py-5 py-md-6",
            title: "Hear from Our Success Stories",
            description:
              "<p>At Hyper Recruitment Solutions, our clients and candidates are our best advocates. Explore their stories and discover how our expertise and dedication have made a difference in their careers and businesses. From seamless job placements to strategic hiring solutions, our testimonials showcase the impact of our award-winning services. See why so many trust us to support their journey and drive success.</p>",
          },
        },
        {
          // hidden until a case study is tagged with this sector's name
          component: "CaseStudiesCarousel",
          props: {
            className: "pt-5 py-md-6",
            title: `${name} Case Studies`,
            tags: [name, url_slug],
          },
        },
        {
          component: "BlogPostsCarousel",
          props: {
            className: "pt-5 py-md-6",
          },
        },
        {
          component: "FAQs",
          props: {
            title: "Frequently Asked Questions",
            description:
              "<p>Explore our Frequently Asked Questions to find answers to common inquiries.</p>",
            sector: id,
            fullWidth: false,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: await getPaths("sectors"),
    fallback: false,
  };
}
